import { useCallback } from "react";
import { useIntl } from "react-intl";

export type MessageValues = Record<string, string | number | undefined | null>;

export type LocalizeFunction = (id: string, values?: MessageValues) => string;

export const useLocalize = (): LocalizeFunction => {
    const intl = useIntl();

    return useCallback(
        (id: string, values?: MessageValues) => {
            return intl.formatMessage({ id }, values);
        },
        [intl]
    );
};
